<template>
    <div class="container">
        <h2 class="unselectable">{{ title }}</h2>
        <div class="textarea">
            <textarea id="textBox" name="textBox" maxlength="800" v-model="comment" placeholder="KIRJOITA TÄHÄN"></textarea>
            <button @click="saveAnswer()">Tallenna vastaus</button>
        </div>
    </div>
</template>

<script>
import { ref, watch } from 'vue';

export default {
    name: 'SummaryAnswer',
    props: {
        title: String,
        comment: String,
        progress: Number
    },
    setup(props, {emit}) {

        const comment = ref('');

        /**
         * If Summary's progress changes, change comment.value to props.comment.
         * This is useful when giving answer to new question or editing an old
         * comment passed as a prop.
         */
        watch(() => props.progress,
            () => {
                comment.value = props.comment;
            }
        );

        const goBack = () => {
            emit("goBack");
        }

        const saveAnswer = () => {
            // Emit given comment to parent component
            emit("answer", comment.value);
        }

        return { goBack, saveAnswer, comment, props };
    },
    emits: ['goBack', 'answer'],
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
html, body, #answerBox {
    margin: 0px;
    padding: 0px;
}

.unselectable {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

h2 {
    text-align: left;
    font-size: 20px;
    margin-bottom: 0;
    padding: 10px;
}

.container {
    width: 70%;
    margin: 30px auto;
    border-radius: 7px;
    background-color: rgb(221, 221, 221);
}

#textBox {
    font-size: 20px;
    text-align: center;
    border: none;
    padding: 10px;
    width: 96.6%;
    height: 150px;
    resize: none;
    text-align: left;
}

button {
    margin: 15px 0;
}

#backButton {
    display: inline-block;
    position: relative;
}

#answerButton {
    display: inline-block;
    position: relative;
}

::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    font-size: 20px;
    color: rgb(180, 180, 180);
    text-transform: capitalize;
    opacity: 1; /* Firefox */
}

</style>
